export default "__VITE_ASSET__CF7kTTiF__$_?component__"